import { render, staticRenderFns } from "./PresenceChangeDialog.vue?vue&type=template&id=4d98dd4b&scoped=true"
import script from "./PresenceChangeDialog.vue?vue&type=script&lang=js"
export * from "./PresenceChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./PresenceChangeDialog.vue?vue&type=style&index=0&id=4d98dd4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d98dd4b",
  null
  
)

export default component.exports